import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Icon from '../../atoms/Icon';

var AppConfig = require('../../../config.json');

/**
 * A simple OrderFormTeacherCheckbox.
 */

class OrderFormTeacherCheckbox extends React.Component {
	constructor(props) {
	  super(props);
		this.handleClick = this.handleClick.bind(this);
	  this.state = {active:this.props.teacher.checkbox, init:false};
	}
	componentDidMount() {
		// if(this.props.teacher.checkbox) {
		// 	this.setState({active:true});
		// }
		this.setState({init:true});
	}


	handleClick(e) {
		var nextState = !this.state.active;
		this.setState({active:!this.state.active});
		this.props.onClick(nextState);
	}

    render () {
        return (
          <div className={`orderformteachercheckbox${this.state.active?" selected":""}`}>
            <div className="toggler">
            	<div className="toggleselect" onClick={this.handleClick}><Icon filename="selected" /></div>
            </div>
            <div className="inner">
            	<div className="desc" onClick={this.handleClick}>
	            	<div className="subline bold" style={{color:"black"}}>
	              		Hiermit bestätige ich, dass die benötigte Bescheinigung ausgefüllt wurde.
	              	</div>
            	</div>
            </div>
            
          </div>
        );
    }

}

OrderFormTeacherCheckbox.propTypes = {
	/** Gets called when the user clicks on the item */
	onClick: PropTypes.func
}

OrderFormTeacherCheckbox.defaultProps = {
	/* eslint-disable no-console */
	onClick: event => {
		console.log('You have clicked a OrderFormTeacherCheckbox Component!', event.target);
	}
	
}


const mapStateToProps = (state) => {
  return {
    teacher: state.status.teacher
  }
}


export default connect(
  mapStateToProps,
  null
)(OrderFormTeacherCheckbox)







// WEBPACK FOOTER //
// ./src/components/molecules/OrderFormTeacherCheckbox/OrderFormTeacherCheckbox.js